import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function ImageIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5882 12.25H2.41176C1.63176 12.25 1 11.5788 1 10.75V2.5C1 1.67125 1.63176 1 2.41176 1H11.5882C12.3682 1 13 1.67125 13 2.5V10.75C13 11.5788 12.3682 12.25 11.5882 12.25Z"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.47922 3.86619C5.93875 4.35444 5.93875 5.14606 5.47922 5.63431C5.01969 6.12256 4.27464 6.12256 3.81511 5.63431C3.35558 5.14605 3.35558 4.35444 3.81511 3.86619C4.27464 3.37794 5.01969 3.37794 5.47922 3.86619"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0001 9.12367L10.61 7.09192C10.3057 6.83317 9.86104 6.88567 9.61751 7.20892L7.80198 9.62017C7.55845 9.94342 7.11445 9.99592 6.80951 9.73717L5.89257 8.95792C5.59257 8.70292 5.15563 8.74942 4.90928 9.06367L2.41187 12.2489"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>

  );
}
